<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <!-- main text -->
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('energyMonitor.about.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('energyMonitor.about.text.01')}}<br>
            {{ $t('energyMonitor.about.text.02')}}<br>
            {{ $t('energyMonitor.about.text.03')}}
            <span
              class="mouse-hover-link"
              @click="downloadItem()"
              target="blank">
              <span style="color: #a91233;">{{$t("common.download")}}</span>
            </span>
          </v-col>
        </v-row>
        <!-- pros checked -->
        <v-row>
          <v-col class="pt-8 display-1">
            {{ $t('energyMonitor.about.text.04')}}
          </v-col>
        </v-row>
        <v-row class="pt-4 pb-8 mx-auto">

          <v-item-group
            v-model="window"
            class="mr-6"
            mandatory
            tag="v-flex">
            <v-item
              v-for="(item,index) in pros"
              :key="index"
              v-slot="{ active, toggle }">
              <div>
                <v-card
                  :input-value="active"
                  flat
                  @click="toggle">
                    <v-row class="ml-0 pl-4 align-center" style="width:100%;">
                      <v-img
                        height="35px"
                        max-width="35px"
                        :src="item.img"
                        class="mr-4"
                        contain>
                      </v-img>
                      <v-col>
                        {{ $t(item.text)}}
                      </v-col>
                    </v-row>
                </v-card>
              </div>
            </v-item>
          </v-item-group>

          <v-divider vertical></v-divider>

          <v-col class="py-0">
            <v-window
              v-model="window"
              vertical>
              <v-window-item
                v-for="(item,index) in pros"
                :key="index">
                <v-card flat>
                  <v-card-text class="py-0">
                    <v-row class="">
                      <v-col
                        v-for="(subitem,index2) in item.subitems"
                        :key="index2"
                        cols="12" md="6"
                        class="px-6">
                        <v-row align="center">
                          <v-col class="pt-0" style="max-width: 60px;">
                            <v-icon
                              size="42"
                              color="success">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </v-col>
                          <v-col>
                            {{ $t(subitem.text)}}
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-window-item>
            </v-window>
          </v-col>

        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'EnergyMonitorAbout',
    extends: DataComponentBase,

    data: () => ({
      window: 0,
      pros: [
        {
          img: require("@/assets/icons/em-pros-01.png"),
          text: "energyMonitor.sections.pros.01.short",
          subitems: [
            { text: "energyMonitor.sections.pros.01.01" },
            { text: "energyMonitor.sections.pros.01.02" },
            { text: "energyMonitor.sections.pros.01.03" },
            { text: "energyMonitor.sections.pros.01.04" },
            { text: "energyMonitor.sections.pros.01.05" },
          ]
        },
        {
          img: require("@/assets/icons/em-pros-02.png"),
          text: "energyMonitor.sections.pros.02.short",
          subitems: [
            { text: "energyMonitor.sections.pros.02.01" },
            { text: "energyMonitor.sections.pros.02.02" },
            { text: "energyMonitor.sections.pros.02.03" },
            { text: "energyMonitor.sections.pros.02.04" },
          ]
        },
        {
          img: require("@/assets/icons/em-pros-03.png"),
          text: "energyMonitor.sections.pros.03.short",
          subitems: [
            { text: "energyMonitor.sections.pros.03.01" },
            { text: "energyMonitor.sections.pros.03.02" },
            { text: "energyMonitor.sections.pros.03.03" },
          ]
        },
        {
          img: require("@/assets/icons/em-pros-04.png"),
          text: "energyMonitor.sections.pros.04.short",
          subitems: [
            { text: "energyMonitor.sections.pros.04.01" },
            { text: "energyMonitor.sections.pros.04.02" },
            { text: "energyMonitor.sections.pros.04.03" },
            { text: "energyMonitor.sections.pros.04.04" },
            { text: "energyMonitor.sections.pros.04.05" },
          ]
        },
        {
          img: require("@/assets/icons/em-pros-05.png"),
          text: "energyMonitor.sections.pros.05.short",
          subitems: [
            { text: "energyMonitor.sections.pros.05.01" },
            { text: "energyMonitor.sections.pros.05.02" },
            { text: "energyMonitor.sections.pros.05.03" },
            { text: "energyMonitor.sections.pros.05.04" },
          ]
        },
        {
          img: require("@/assets/icons/em-pros-06.png"),
          text: "energyMonitor.sections.pros.06.short",
          subitems: [
            { text: "energyMonitor.sections.pros.06.01" },
            { text: "energyMonitor.sections.pros.06.02" },
            { text: "energyMonitor.sections.pros.06.03" },
            { text: "energyMonitor.sections.pros.06.04" },
          ]
        },
        // { text: "energyMonitor.about.pros.02" },
        // { text: "energyMonitor.about.pros.03" },
        // { text: "energyMonitor.about.pros.04" },
        // { text: "energyMonitor.about.pros.05" },
        // { text: "energyMonitor.about.pros.06" },
      ],
    }),

    methods: {
      downloadItem () {
        let url = './RubinEnergymonitor_leflet.pdf'
        let label = "RubinEnergymonitor_leflet"
        window.open(url)
      }
    },
  }
</script>
